import { cases } from "../config/cases";


export const casesConsult = () => {
  return cases.casesConsult().then(response => response)
};

export const casesCreated = (caseCreate) => {
  return cases.casesCreated(caseCreate).then(response => response)
};

export const editCase = (data) => {
  return cases.editCase(data).then(response => response)
};

export const editCases = (data) => {
  return cases.editCases(data).then(response => response)
};

export const getCasesMenu = (data) => {
  return cases.getCasesMenu(data).then(response => response)
};
export const getLimitsMenu = (data) => {
  return cases.getLimitsMenu(data).then(response => response)
};

export const getDeleteCases = (data) => {
  return cases.getDeleteCases(data).then(response => response)
};

export const element = (data) => {
  return cases.element(data).then(response => response)
};
